import { HighlightComparisonCard as HighlightComparisonCard$1, ComparisonCard } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_COMPARISON_CARD_CONTENT_MODEL_ID = 'cdxHighlightComparisonCard';
function HighlightComparisonCard({
  headline,
  subhead,
  ctaButtonLabel,
  ctaButtonUrl,
  style = 'default',
  hasSpacingTop,
  cards = [],
  anchor
}) {
  return /*#__PURE__*/jsx(HighlightComparisonCard$1, {
    headline: headline,
    subhead: subhead,
    ctaButtonLabel: ctaButtonLabel,
    hasSpacingTop: hasSpacingTop,
    ctaButtonUrl: ctaButtonUrl,
    style: style,
    anchor: anchor,
    cardCount: cards.length,
    children: cards.map((card, index) => {
      const navLink = card?.fields?.link && mapEntryLink(card?.fields?.link);
      return /*#__PURE__*/jsx(ComparisonCard, {
        title: card?.fields.title,
        subtitle: card?.fields.subtitle,
        description: card?.fields.description,
        ctaUrl: navLink?.url,
        ctaLabel: navLink?.label,
        listTitle: card?.fields?.listTitle,
        list: card?.fields?.list,
        listStyle: card?.fields?.listStyle
      }, index);
    })
  });
}
export { HIGHLIGHT_COMPARISON_CARD_CONTENT_MODEL_ID, HighlightComparisonCard };
//# sourceMappingURL=HighglightComparisonCard.js.map
